// Stripe product configuration
export const stripeProducts = {
  tankControl5min: {
    priceId: 'price_tank_5min', // Replace with actual Stripe price ID
    name: 'tankControl.packages.5min.name',
    description: 'tankControl.packages.5min.description',
    mode: 'payment' as const,
    price: 25, // CZK
    duration: 5
  },
  tankControl15min: {
    priceId: 'price_tank_15min', // Replace with actual Stripe price ID  
    name: 'tankControl.packages.15min.name',
    description: 'tankControl.packages.15min.description',
    mode: 'payment' as const,
    price: 60, // CZK
    duration: 15
  },
  tankControl30min: {
    priceId: 'price_tank_30min', // Replace with actual Stripe price ID
    name: 'tankControl.packages.30min.name', 
    description: 'tankControl.packages.30min.description',
    mode: 'payment' as const,
    price: 100, // CZK
    duration: 30
  }
};

export type StripeProductKey = keyof typeof stripeProducts;